var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.333,
    height: 26.965,
    viewBox: "0 0 35.333 26.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "back",
    d: "M35.42,13.917a1.865,1.865,0,0,1-1.86,1.86H6.41l8.415,8.461a1.852,1.852,0,0,1,0,2.65,1.826,1.826,0,0,1-1.3.511,1.759,1.759,0,0,1-1.3-.558L.645,15.219a1.8,1.8,0,0,1,0-2.6L12.221.993a1.852,1.852,0,0,1,2.65,0,1.852,1.852,0,0,1,0,2.65L6.41,12.058H33.56A1.865,1.865,0,0,1,35.42,13.917Z",
    transform: "translate(-0.087 -0.435)",
    fill: "blue"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.b416493659184bd9c29cd97d46c9b3bb.svg";
export { ForwardRef as ReactComponent };